import { FC, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import { useUserContext } from '@/contexts/user';
import { formDataSessionStorage } from '@/storages/signUp/formData';

interface ArgSignupConfirmRouteProps {
  Component: FC;
}

const SignUpConfirmRoute: FC<ArgSignupConfirmRouteProps> = ({ Component }) => {
  const { isLoggedIn, isGuest } = useUserContext();

  // 会員登録Mutation実行時にuserContextのstateが更新される。
  // その際に以下のリダイレクト判定が再実行されるのを防ぐ。
  const isRedirect = useMemo(() => {
    return formDataSessionStorage.get() === null || !isLoggedIn || !isGuest;
  }, []);

  if (isRedirect) {
    return <Navigate to="/signup" />;
  }

  return <Component />;
};

export default SignUpConfirmRoute;
